<script setup>
import { getClient } from '@/core/js/GraphqlClient.js';
import { useStore } from '@/store/Store.js';
import DiscountsPromoCode from '@/components/discounts-listing/DiscountsPromoCode.vue';

const props = defineProps({
    title: { type: String, default: '' },
    grocery: { type: Object, default: () => {} },
});
const store = useStore();
const client = getClient();
const variables = {
    lang: store.lang.value,
    grocery: props.grocery ? props.grocery.id : ':empty:',
};

const { data } = await client.executeQuery({
    variables,
    query: `query FetchEntries($lang: [String], $grocery: [QueryArgument]) {
        promoCodes: entries(section: "promoCode", site: $lang, promoGrocery: $grocery) {
            id,
            title,
            ... on promoCode_Entry {
                promoCode,
                promoBrand,
                promoDescription,
                promoNotes,
                promoUrl
            }
        }
    }`,
    cachePolicy: 'cache-and-network',
});
</script>

<template>
    <h3
        v-if="data?.promoCodes?.length > 0 && title"
        class="h4 mb-4"
    >
        {{ title }}
    </h3>
    <div
        v-if="data.promoCodes.length > 0"
        class="DiscountsPromoCodesListing mb-4 grid grid-cols-1 gap-4 md:grid-cols-3"
    >
        <DiscountsPromoCode
            v-for="code in data.promoCodes"
            :key="code.id"
            :title="code.title"
            :code="code.promoCode"
            :description="code.promoDescription"
            :notes="code.promoNotes"
            :brand="code.promoBrand"
            :url="code.promoUrl ?? (grocery ? grocery.url : null)"
        />
    </div>
</template>
